import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Region`;


const ApiRegion = {
    getRegions: () => {
   
    const url = `${baseServiceUrl}`;
    
    return ServiceApi.get(url);
  },
};

export default ApiRegion;